module.exports = __webpack_public_path__ + "static/media/Solution Device Hub Infographic - GBR Tech - 01-04-2025 C.1519ec10.gif";